import queryString from 'query-string';
import NewsLetter from './NewsLetter';

const { TRAVIS } = window;
const q = queryString.parse(window.location.search);

if (!window.location.href.includes('?password=') && window.location.href.includes('/password')) {
  // remove password from url with push state no hisory
  window.history.pushState({}, '', window.location.href.replace('/password', ''));
}

const body = document.getElementsByTagName('body')[0];
body.classList.add('js-body-ready');
setTimeout(() => body.classList.add('js-ready'), 100);

function login(pass) {
  console.log('login');
  const input = document.querySelector('.js-password');
  if (!input) return;
  input.value = pass;
  input.closest('form').submit();
}

(() => {
  if (TRAVIS.redirect && !q.password) {
    window.top.location.href = TRAVIS.redirect;
    return;
  }
  const news = document.querySelector('.js-newsletter');
  if (news) new NewsLetter(news);

  const el = document.querySelector('.js-password-wrap');

  if (!el) return; // console.error('NO PASSWORD EL');

  const errors = el.querySelector('.errors');
  const input = el.querySelector('.js-password');

  if (q.s) {
    return login(q.s);
  }
  if (q.k || q.password || errors) {
    el.style.display = 'block';
    const newsletter = document.querySelector('.js-newsletter');
    if (newsletter) newsletter.style.display = 'none';
    [...document.querySelectorAll('.js-hide-pass')].forEach((p_el) => {
      p_el.style.display = 'none';
    });
  }

  if (!errors) return;
  input.classList.add('js-error');
  return input.addEventListener('input', () => input.classList.remove('js-error'));
})();
